import React from 'react';
import TemplateStringInput from '~/components/organism/TemplateStringInput';
import useDHEditorInFlowBuilder from '../../../../hooks/useDHEditorInFlowBuilder';
import type { FlowV2_ParameterMappingFragment } from '~/graphql/types';
import type { EditorValue } from '~/components/organism/PluginsEditor/types';

export type Props = {
  html: string | null | undefined;
  mappings: Array<FlowV2_ParameterMappingFragment> | undefined;
  actionId: string;
  /** Makes the editor single line by disabling Enter key press. Default is true. */
  singleLine?: boolean;
  updaterFn: (value: EditorValue) => void;
};

const TemplateStringField: React.FCC<Props> = ({
  dataTestId,
  html,
  mappings,
  actionId,
  singleLine = true,
  updaterFn,
}) => {
  const { key, value, onChange } = useDHEditorInFlowBuilder({
    actionId,
    html: html || '',
    mappings: mappings || [],
    updaterFn,
  });

  return (
    <TemplateStringInput
      singleLine={singleLine}
      $key={key}
      onChange={onChange}
      value={value}
      dataTestId={dataTestId}
    />
  );
};

export default TemplateStringField;
